module.exports = __webpack_public_path__ + "static/media/registration_success.06cea60d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tiendas/registration_success.png
// module id = 2185
// module chunks = 0